import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from './ui/carousel';
import { cn } from '../lib/utils';

interface Slide {
  src: string;
  link?: string;
  text?: string;
}

const slides: Slide[] = [
  { src: '/images/slider/slide1.png' },
  { src: '/images/slider/slide2.png' },
  { 
    src: '/images/slider/slide3.png',
    link: '/tyres?season=Зимние',
    text: 'Зимние шины: множество позиций от ведущих производителей'
  },
];

export default function HomeCarousel() {
  const navigate = useNavigate();
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);

  React.useEffect(() => {
    if (!api) return;
    setCurrent(api.selectedScrollSnap());
    api.on('select', () => setCurrent(api.selectedScrollSnap()));
  }, [api]);

  const handleSlideClick = (slide: Slide) => {
    if (slide.link) {
      navigate(slide.link);
    }
  };

  return (
    <div className="mx-auto w-full">
      <Carousel setApi={setApi} className="w-full" opts={{ loop: true }}>
        <CarouselContent>
          {slides.map((slide, index) => (
            <CarouselItem
              key={`${slide.src}-${index}`}
              className="basis-[90%] sm:basis-[80%] lg:basis-[70%]"
            >
              <Card
                className={cn('overflow-hidden transition-opacity duration-500 relative', {
                  'opacity-30': index !== current,
                  'cursor-pointer': slide.link,
                })}
                onClick={() => handleSlideClick(slide)}
              >
                <CardContent className="p-0 relative">
                  <img
                    src={slide.src}
                    alt={`Слайд ${index + 1}`}
                    className="w-full h-[240px] sm:h-[300px] lg:h-[380px] object-cover rounded-xl"
                  />
                  {slide.text && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-xl">
                      <div className="text-center px-4">
                        <p className="text-white text-lg sm:text-xl lg:text-2xl font-semibold drop-shadow-lg">
                          {slide.text}
                        </p>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </div>
  );
}

